import { config } from 'config'
import { requestAPI } from 'utils/api'

export const readFindPlayer = (ulid: string) => {
  return requestAPI({
    method: 'GET', url: `/searchtool/findplayer/${ulid}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePlayerInfo = (ulid: string, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/searchtool/findplayer/${ulid}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readFindPlayerAnalysis = (ulid: string) => {
  return requestAPI({
    method: 'GET', url: `/searchtool/findplayer/${ulid}/analysis`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readFindPlayerAdValue = (ulid: string) => {
  return requestAPI({
    method: 'GET', url: `/searchtool/findplayer/${ulid}/advalue`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const postBanPlayer = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: `/searchtool/findplayer/ban`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const postRefund = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: `${config.billing}/refund`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const postForceWithdrawal = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: `/searchtool/findplayer/withdraw`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const postInitializePassword = (ulid: string) => {
  return requestAPI({
    method: 'POST', url: `/searchtool/initialize-password/${ulid}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const postDeleteAccount = (ulid: string) => {
  return requestAPI({
    method: 'POST', url: `/searchtool/unreg/account/${ulid}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readCustomerSupport = (params: { start_time: any, end_time: any, account_ulid: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/cs', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGameLeagueData = (params: { start_time: any, end_time: any, account_ulid: any, league_id: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/gameleague', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readDDTourData = (params: { start_time: any, end_time: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/ddtour/data', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readDDTourRewards = () => {
  return requestAPI({
    method: 'GET', url: '/searchtool/ddtour/rewards'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const ReadTransactionHistoryRC = (params: { start_time: any, end_time: any, transaction_type: any, account_ulid: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/transactionrc/history', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadTransactionTypesRC = () => {
  return requestAPI({
    method: 'GET', url: '/searchtool/transactionrc/types'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadTransactions = (params: { start_date: any, end_date: any, currency_types: any, account_ulid: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/transaction/history', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadTransactionMCode = () => {
  return requestAPI({
    method: 'GET', url: '/searchtool/transaction/mcode'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadWallets = (params: { account_ulid: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/wallet', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadWithdrawals = (params: { account_ulid: any, status: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/withdrawals', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadWithdrawalUserHistory = (params: { account_ulid: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/withdrawals/history', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const EvaluateWithdrawal = (id: string, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/searchtool/withdrawal/evaluate/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const sendPushMessage = (params: {
  account_ulid: any,
  title: any,
  body: any,
  use_localized_key?: any,
  title_loc_key?: any,
  body_loc_key?: any
}) => {
  return requestAPI({
    method: 'POST', url: '/fcm/push/custom', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadWithdrawalStatuses = () => {
  return requestAPI({
    method: 'GET', url: '/searchtool/withdrawals/statuses'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadAccountDeleteHistory = (params: { request_date: any, account_ulid: any, nickname: any, email: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/accountdelete/history', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadAccountInfo = (params: { device_id: any, account_ulid: any, nickname: any, email: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/accountinfo', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadPurchaseTrx = (params: { transaction_id: any }) => {
  return requestAPI({
    method: 'GET', url: '/searchtool/purchase/trx', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const ReadDevStats = () => {
  return requestAPI({
    method: 'GET', url: '/searchtool/devstats'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}
